

import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import {
  getLoyaltyTemplates,
  updateLoyaltyTemplate,
  createLoyaltyTemplate,
  deleteLoyaltyTemplate
} from '@/api/new-api/loyalty/template'
import { sortTemplatesBySerial } from '@/lib/loyalty-template-utils'

// Async Thunks

export const fetchLoyaltyTemplates = createAsyncThunk(
  'loyalty/fetchTemplates',
  async (params, { rejectWithValue }) => {
    const res = await getLoyaltyTemplates(params)
    if (res.status === 'success') return res.data.loyalty_templates
    return rejectWithValue(res.message)
  }
)

export const addLoyaltyTemplate = createAsyncThunk(
  'loyalty/addTemplate',
  async (data, { rejectWithValue }) => {
    const res = await createLoyaltyTemplate(data)
    if (res.status === 'success') return res.data.loyalty_template
    return rejectWithValue(res.message)
  }
)

export const editLoyaltyTemplate = createAsyncThunk(
  'loyalty/editTemplate',
  async ({ template_id, data }, { rejectWithValue }) => {
    const res = await updateLoyaltyTemplate(template_id, data)
    if (res.status === 'success') return res.data.loyalty_template
    return rejectWithValue(res.message)
  }
)

export const removeLoyaltyTemplate = createAsyncThunk(
  'loyalty/removeTemplate',
  async (template_id, { rejectWithValue }) => {
    const res = await deleteLoyaltyTemplate(template_id)
    if (res.status === 'success') return template_id
    return rejectWithValue(res.message)
  }
)

// Slice

const loyaltySlice = createSlice({
  name: 'loyalty',
  initialState: {
    templates: [],
    getLoading: false,
    createLoading: false,
    updateLoading: false,
    deleteLoading: false,
    error: null
  },
  reducers: {
    clearLoyaltyError: state => {
      state.error = null
    }
  },
  extraReducers: builder => {
    builder
      .addCase(fetchLoyaltyTemplates.pending, state => {
        state.getLoading = true
        state.error = null
      })
      .addCase(fetchLoyaltyTemplates.fulfilled, (state, action) => {
        state.getLoading = false
        state.templates = sortTemplatesBySerial(action.payload)
      })
      .addCase(fetchLoyaltyTemplates.rejected, (state, action) => {
        state.getLoading = false
        state.error = action.payload
      })
      .addCase(addLoyaltyTemplate.pending, state => {
        state.createLoading = true
        state.error = null
      })
      .addCase(addLoyaltyTemplate.fulfilled, (state, action) => {
        state.createLoading = false
        state.templates = sortTemplatesBySerial([...state.templates, action.payload])
      })
      .addCase(addLoyaltyTemplate.rejected, (state, action) => {
        state.createLoading = false
        state.error = action.payload
      })
      .addCase(editLoyaltyTemplate.pending, state => {
        state.updateLoading = true
        state.error = null
      })
      .addCase(editLoyaltyTemplate.fulfilled, (state, action) => {
        state.updateLoading = false
        const index = state.templates.findIndex(
          template => template.id === action.payload.id
        )
        if (index !== -1) {
          state.templates[index] = action.payload
          state.templates = sortTemplatesBySerial(state.templates)
        }
      })
      .addCase(editLoyaltyTemplate.rejected, (state, action) => {
        state.updateLoading = false
        state.error = action.payload
      })
      .addCase(removeLoyaltyTemplate.pending, state => {
        state.deleteLoading = true
        state.error = null
      })
      .addCase(removeLoyaltyTemplate.fulfilled, (state, action) => {
        state.deleteLoading = false
        state.templates = state.templates.filter(
          template => template.id !== action.payload
        )
      })
      .addCase(removeLoyaltyTemplate.rejected, (state, action) => {
        state.deleteLoading = false
        state.error = action.payload
      })
  }
})

export const { clearLoyaltyError } = loyaltySlice.actions
export default loyaltySlice.reducer
